import React from 'react'
import { Button, CircularProgress, Paper, useTheme } from '@material-ui/core'

const Destiny = ({ loading: dataIsLoading, onSetPool, pool = {}, titleClass }) => {
  const theme = useTheme()
  const isDarkMode = theme.palette.type === 'dark'
  const [ loading, setLoading ] = React.useState(false)
  const poolValues = Object.values(pool)
  const poolLength = poolValues.length

  const onClick = async (action, idx) => {
    setLoading(true)
    await onSetPool(action, idx)
    setTimeout(() => {
      setLoading(false)
    }, 10)
  }

  return (
    <div css={`
      position: relative;
    `}>
      <div css={`
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        pointer-events: none;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2;
      `}>
        <div className={loading ? 'loading' : ''} css={`
          opacity: 0;
          transition: opacity 0.1s ease-in-out;

          &.loading {
            opacity: 1;
          }
        `}>
          <CircularProgress />
        </div>
      </div>

      <div css={`
        display: flex;
        justify-content: space-between;
        align-items: center; 
        margin-bottom: 6px;
        opacity: ${loading ? 0.5 : 1};
      `}>
        <div css={`display: flex;`}>
          <span className={titleClass} css={`margin-bottom: 0;`}>
            Destiny
          </span>
        </div>
        <div css={`
          button {
            padding: 2px 6px;
            touch-action: manipulation;
          }
        `}>
          <Button variant='outlined' disabled={dataIsLoading || loading} type='button' css={`margin-right: 8px;`} onClick={() => onClick('addLight')}>
            + Light
          </Button>
          <Button variant='outlined' disabled={dataIsLoading || loading} type='button' css={`margin-right: 8px;`} onClick={() => onClick('addDark')}>
            + Dark
          </Button>
          <Button variant='outlined' disabled={dataIsLoading || loading || poolLength === 0} type='button' css={`margin-right: 8px;`} onClick={() => onClick('remove')}>
            - Token
          </Button>
          <Button variant='outlined' disabled={dataIsLoading || loading || poolLength === 0} type='button' onClick={() => onClick('clear')}>
            Clear
          </Button>
        </div>
      </div>

      <Paper variant='outlined' css={`
        display: flex;
        align-items: center;
        min-height: 62px;
        opacity: ${loading ? 0.4 : 1};
      `}>
        {dataIsLoading ?
          <p css={`flex: 1; text-align: center;`}>
            Loading...
          </p>
          :
          poolLength === 0 ?
            <div css={`flex: 1; text-align: center; color: ${theme.palette.text.secondary};`}>
              Destiny pool is empty
            </div>
            :
            <div css={`
              padding: 4px 8px 8px 4px;
              display: flex;
              flex-wrap: wrap;

              div {
                margin: 4px 0px 0 4px;
              }
            `}>
              {poolValues.map((value, idx) => {
                return (
                  <div
                    title='Flip'
                    key={idx}
                    css={`
                      cursor: pointer;
                      border-radius: 50%;
                      height: 40px;
                      width: 40px;
                      border: 3px solid black;
                      background-color: ${value === 1 ? 'white' : 'black'};
                      &:hover {
                        box-shadow: 0px 0px 10px 2px ${isDarkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)'};
                      }
                    `}
                    onClick={() => {
                      onClick('toggle', idx)
                    }}
                  />
                )
              })}
            </div>
        }
      </Paper>
    </div>
  )
}

export default Destiny
